module.exports = __webpack_public_path__ + "img/img22.1265cd63.svg";